module.exports = __webpack_public_path__ + "img/ormas_picture.01693be1.png";